import React from 'react';
import { ZoomCameraFillIcon } from '@bizzabo/icons';
import { getVirtualSessionEndPoint } from '../../ApiUtil';

const ZoomExternalBreakoutRooms = ({ participantUrl, sessionId, eventId }) => {
    const joinZoomMeeting = () => {
        if (!participantUrl) {
            return;
        }

        // send checkin when open external link
        getVirtualSessionEndPoint({ sessionId, eventId, shouldSendCheckin: true });
        window.open(participantUrl);
    };

    return (
        <div className="zoom-external">
            <p className="caption-title">
                Join Breakout Rooms on Zoom
            </p>
            <p className="text-center">
                This session will be on Zoom and will open in a new page
            </p>
            <button
                type="button"
                className="text-uppercase bz-button font-size-13 custom-color color-1-background color-1-hover-opacity"
                onClick={joinZoomMeeting}
            >
                <ZoomCameraFillIcon className="zoom-camera-icon"/>
                Join Breakout Rooms on Zoom
            </button>
        </div>
    );
};

export default ZoomExternalBreakoutRooms;
